<template>
	<div class="title clearfix" v-show="titleBoxConfig.showBox">
		<div class="title_l fl" v-show="true" @click="backFn()"><img src="../../../static/img/gloable/back@3x.png"></div>
		<div class="title_c fl" v-if="true">{{titleBoxConfig.titleContent}}</div>
		<div class="title_r fr" v-show="true" @click="closeFn()"><img src="../../../static/img/gloable/multiply@3x.png"></div>
	</div>
</template>
<script>

export default {
	name: 'titleTop',
	props: ['titleBoxConfig'],
	data () {
		return {

		}
	},
	methods: {
		backFn: function () {
			let eventVal = this.getCookie("back_button_event");
			!!eventVal ? eval(eventVal) : this.$router.back();
			this.$router.back();

		},
		closeFn: function () {
			let eventVal = this.getCookie("close_button_event");
			!!eventVal ? eval(eventVal) : window.close();
		},

	},
	mounted () {

	},
	computed: {
	}

}
</script>
<style lang="scss" scoped>
.title {
  position: fixed;
  z-index: 9999;
  width: 16rem;
  height: 2.2rem;
  line-height: 2.2rem;
  background: rgba(57, 58, 63, 0.8);
  color: #fff;
  text-align: center;
  font-size: 0.75rem;
  top: 0;
  .title_l {
    padding-left: 0.6rem;
    width: 2.2rem;
    height: 0.9rem;
    padding-top: 0.65rem;
    text-align: left;
    img {
      width: 0.5rem;
      height: 0.9rem;
    }
  }
  .title_c {
    width: 10.4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title_r {
    width: 2.2rem;
    height: 1.4rem;
    text-align: right;
    padding: 0.65rem 0.6rem 0 0;
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// title.vue?5a700918